import { render, staticRenderFns } from "./ProductStatsOverviewTable.vue?vue&type=template&id=5f7509f2&"
import script from "./ProductStatsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./ProductStatsOverviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports